import { BannerCard, Title, Description } from "./SectionTitle.styles";

interface SectionTitleProps {
  title: string;
  description: string[];
}

export const SectionTitle = ({ title, description }: SectionTitleProps) => {
  return (
    <BannerCard>
      <Title>{title}</Title>
      <Description>
        {description.map((item, index) => (
          <p key={index}>
            {item}
          </p>
        ))}
      </Description>
    </BannerCard>
  );
};
